import { getToken } from '@ctsu/loader';
import { merge } from 'lodash/fp';

async function request(url, config) {
  let jsonResponse;
  let textResponse;
  let blobResponse;
  let fileName = '';
  try {
    const response = await fetch(url, config);
    if (response.status === 200) {
      const ContentType = response.headers.get('Content-Type');
      if (ContentType === 'application/octet-stream') {
        fileName = response.headers.get('content-disposition');
        blobResponse = await response.blob();
        return { blobResponse, fileName };
      }
      try {
        textResponse = await response.text();
        jsonResponse = JSON.parse(textResponse);
        return jsonResponse;
      } catch (err) {
        return textResponse;
      }
    } else {
      try {
        textResponse = await response.json();
      } catch (error) {
        return textResponse;
      }
      return Promise.reject(textResponse);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

async function makeRequest(url, method, $body, auth, header, signal) {
  const token = getToken();
  const $headers = header || new Headers();
  const $url = `${process.env.REACT_APP_ORIGIN}${url}`;
  $headers.append('Content-Type', 'application/json');
  let params = {
    crossDomain: false,
    withCredentials: true,
    headers: $headers
  };

  if (auth) {
    $headers.append('Authorization', `Bearer ${token}`);
  } else {
    $headers.append('appName', process.env.REACT_APP_NAME);
    params = { ...params, crossDomain: true, credentials: 'include' };
  }
  const requestBody = $body;
  // if Abort controller is present in the body the set it to the fetch options.
  if (requestBody && requestBody.abortSignal) {
    params.signal = requestBody.abortSignal;
    delete requestBody.abortSignal;
  }

  if (requestBody) {
    if (typeof requestBody !== 'string') {
      params.body = JSON.stringify(requestBody);
    } else {
      params.body = requestBody;
    }
  }
  const requestConfig = merge({ method, signal }, params);
  const data = await request($url, requestConfig);
  return data;
}

// Pass signal param from an instance of AbortController,
// then use the controller instance's .abort() method to abort the API call in useEffect return,
// in order to abort current API call when a new API call started.`
const fetchWithAuth = (url, signal) =>
  Promise.resolve(makeRequest(url, 'GET', false, true, null, signal));

const postWithAuth = (url, body, signal) =>
  Promise.resolve(makeRequest(url, 'POST', body, true, null, signal));

const putWithAuth = (url, body) =>
  Promise.resolve(makeRequest(url, 'PUT', body, true));

const deleteWithAuth = (url) =>
  Promise.resolve(makeRequest(url, 'DELETE', false, true));

const patchWithAuth = (url, body) =>
  Promise.resolve(makeRequest(url, 'PATCH', body, true));

const fetchData = (url, header) =>
  Promise.resolve(makeRequest(url, 'GET', false, false, header));

const postData = (url, body) =>
  Promise.resolve(makeRequest(url, 'POST', body, false));

const putData = (url, body) =>
  Promise.resolve(makeRequest(url, 'PUT', body, false));

export {
  deleteWithAuth,
  fetchData,
  fetchWithAuth,
  makeRequest,
  patchWithAuth,
  postData,
  postWithAuth,
  putData,
  putWithAuth,
  request
};
